export const SET_GUEST_MANAGER = 'SET_GUEST_MANAGER';
export const SET_GUEST_USERS = 'SET_GUEST_USERS';
export const EDIT_GUEST_USERS = 'EDIT_GUEST_USERS';
